var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"white","fillOpacity":"0.1","key":0}),React.createElement("path",{"d":"M35 13L23.12 14.76V23.56L35 23.45V13ZM22.02 24.55L13 24.44V31.92L21.91 33.13L22.02 24.55ZM13 16.08V23.56H21.91V14.87L13 16.08ZM23.01 24.55V33.24L35 35V24.66L23.01 24.55Z","fill":"white","fillOpacity":"0.8","key":1})]);
}

Windows.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
